// keep list sorted alphabetically
export enum ChainId {
  AAVEGOTCHI_TESTNET = 10191,
  ALFAJORES = 10125,
  APTOS = 108,
  APTOS_TESTNET = 10108,
  APTOS_TESTNET_SANDBOX = 20308,
  ARCANA = 117,
  ARCANA_TESTNET = 10117,
  ARCANA_TESTNET_SANDBOX = 20117,
  ARBITRUM = 110,
  ARBITRUM_GOERLI = 10143,
  ARBITRUM_GOERLI_SANDBOX = 20143,
  ARBITRUM_RINKEBY = 10110,
  ARBITRUM_RINKEBY_SANDBOX = 20110,
  ASTAR = 210,
  ASTAR_TESTNET = 10210,
  ASTAR_TESTNET_SANDBOX = 20146,
  AURORA = 211,
  AURORA_TESTNET = 10201,
  AURORA_TESTNET_SANDBOX = 20129,
  AVALANCHE = 106,
  BASE = 184,
  BASE_TESTNET = 10160,
  BEAM = 198,
  BEAM_TESTNET = 10178,
  BLOCKGEN_TESTNET = 10177,
  BOBA = 127,
  BOBA_TESTNET = 10144,
  BOBA_TESTNET_SANDBOX = 20144,
  BSC = 102,
  BSC_TESTNET = 10102,
  BSC_TESTNET_SANDBOX = 20102,
  CANTO = 159,
  CANTO_TESTNET = 10159,
  CASTLECRUSH = 119,
  CASTLECRUSH_TESTNET = 10119,
  CASTLECRUSH_TESTNET_SANDBOX = 20119,
  CELO = 125,
  CELO_TESTNET = 10125,
  CELO_TESTNET_SANDBOX = 20125,
  CHIADO = 10145,
  CONFLUX = 212,
  CONFLUX_TESTNET = 10211,
  COREDAO = 153,
  COREDAO_TESTNET = 10153,
  DEXALOT = 118,
  DEXALOT_TESTNET = 10118,
  DEXALOT_TESTNET_SANDBOX = 20118,
  DFK = 115,
  DFK_TESTNET = 10115,
  DFK_TESTNET_SANDBOX = 20115,
  DOS = 149,
  DOS_TESTNET = 10162,
  ETHEREUM = 101,
  EON = 215,
  EON_TESTNET = 10215,
  FANTOM = 112,
  FANTOM_TESTNET = 10112,
  FANTOM_TESTNET_SANDBOX = 20112,
  FRAME_TESTNET = 10222,
  FUJI = 10106,
  FUJI_SANDBOX = 20106,
  FUSE = 138,
  FUSE_TESTNET = 10138,
  FUSE_TESTNET_SANDBOX = 20138,
  GNOSIS = 145,
  GNOSIS_TESTNET = 10145,
  GNOSIS_TESTNET_SANDBOX = 20145,
  GOERLI = 10121,
  GOERLI_MAINNET = 154,
  GOERLI_SANDBOX = 20121,
  HARMONY = 116,
  HARMONY_TESTNET = 10133,
  HARMONY_TESTNET_SANDBOX = 20133,
  HOLESKY_TESTNET = 10217,
  HUBBLE_TESTNET = 10182,
  IDEX_TESTNET = 10219,
  INTAIN = 152,
  INTAIN_TESTNET = 10152,
  INTAIN_TESTNET_SANDBOX = 20152,
  KAVA = 177,
  KAVA_TESTNET = 10172,
  KIWI_TESTNET = 10209,
  KLAYTN = 150,
  KLAYTN_TESTNET = 10150,
  KOVAN = 10120,
  KOVAN_SANDBOX = 20120,
  LINEA_GOERLI = 10157,
  LOOT = 197,
  LOOT_TESTNET = 10197,
  MANTA_TESTNET = 10221,
  MANTLE = 181,
  MANTLE_TESTNET = 10181,
  METIS = 151,
  METIS_GOERLI = 10151,
  METIS_TESTNET = 10151,
  MOONBASE = 10126,
  MOONBEAM = 126,
  MOONBEAM_TESTNET = 10126,
  MOONBEAM_TESTNET_SANDBOX = 20126,
  MOONRIVER = 167,
  MUMBAI = 10109,
  MUMBAI_SANDBOX = 20109,
  METER = 176,
  METER_TESTNET = 10156,
  NOVA = 175,
  ODA_TESTNET = 10208,
  OKX = 155,
  OKX_TESTNET = 10155,
  OPBNB = 202,
  OPBNB_TESTNET = 10202,
  OPTIMISM = 111,
  OPTIMISM_GOERLI = 10132,
  OPTIMISM_GOERLI_SANDBOX = 20132,
  OPTIMISM_KOVAN = 10111,
  OPTIMISM_KOVAN_SANDBOX = 20111,
  ORDERLY = 213,
  ORDERLY_TESTNET = 10200,
  PGN_TESTNET = 10223,
  POLYGON = 109,
  POLYGONCDK_TESTNET = 10224,
  PORTAL = 128,
  PORTAL_TESTNET = 10128,
  PORTAL_TESTNET_SANDBOX = 20128,
  PGJJTK_TESTNET = 10207,
  RINKEBY = 10101,
  RINKEBY_SANDBOX = 20101,
  SCROLL = 214,
  SCROLL_TESTNET = 10214,
  SEPOLIA = 161,
  SEPOLIA_TESTNET = 10161,
  SHIMMER = 230,
  SHIMMER_TESTNET = 10203,
  SHRAPNEL = 148,
  SHRAPNEL_TESTNET = 10164,
  SOLANA = 168,
  SOLANA_TESTNET = 10168,
  SPRUCE_TESTNET = 10206,
  SWIMMER = 114,
  SWIMMER_TESTNET = 10130,
  SWIMMER_TESTNET_SANDBOX = 20130,
  TELOS = 199,
  TELOS_TESTNET = 10199,
  TENET = 173,
  TENET_TESTNET = 10173,
  TOMO = 196,
  TOMO_TESTNET = 10196,
  XPLA = 216,
  XPLA_TESTNET = 10216,
  ZKATANA_TESTNET = 10220,
  ZKCONSENSYS = 183,
  ZKCONSENSYS_TESTNET = 10157,
  ZKPOLYGON = 158,
  ZKPOLYGON_TESTNET = 10158,
  ZKSYNC = 165,
  ZKSYNC_TESTNET = 10165,
  ZORA = 195,
  ZORA_TESTNET = 10195,
}
